import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card shadow-sm" }
const _hoisted_2 = { class: "card-header d-flex align-items-center" }
const _hoisted_3 = { class: "badge bg-secondary ms-2" }
const _hoisted_4 = { class: "card-body p-0" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table table-sm align-middle mb-0" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = ["id", "aria-expanded", "aria-controls", "onClick"]
const _hoisted_10 = { class: "text-nowrap small" }
const _hoisted_11 = { class: "text-nowrap" }
const _hoisted_12 = {
  class: "text-truncate",
  style: {"max-width":"12rem"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_15 = { class: "text-end text-nowrap" }
const _hoisted_16 = { class: "text-end text-nowrap" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = {
  key: 0,
  class: "text-danger",
  title: "Rechazado"
}
const _hoisted_19 = {
  key: 1,
  class: "d-flex justify-content-center gap-1"
}
const _hoisted_20 = {
  key: 0,
  class: "fas fa-check-circle text-success",
  title: "Aprobado"
}
const _hoisted_21 = {
  key: 1,
  class: "far fa-circle text-muted",
  title: "Pendiente"
}
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = {
  colspan: "6",
  class: "bg-light"
}
const _hoisted_24 = { class: "p-3" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "d-flex justify-content-end gap-2 mt-3" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = {
  class: "form-control form-control-sm bg-white",
  readonly: ""
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_33 = { class: "mb-3" }
const _hoisted_34 = {
  class: "form-control form-control-sm bg-white",
  style: {"min-height":"48px"},
  readonly: ""
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_37 = { class: "table-responsive" }
const _hoisted_38 = { class: "table table-sm align-middle mb-3" }
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = { class: "text-truncate" }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = { class: "text-end text-nowrap" }
const _hoisted_43 = { class: "text-end text-nowrap" }
const _hoisted_44 = { class: "text-truncate" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "text-end text-nowrap text-muted" }
const _hoisted_48 = { class: "text-end text-nowrap text-muted" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "text-end text-nowrap text-muted" }
const _hoisted_51 = { class: "text-end text-nowrap text-muted" }
const _hoisted_52 = { class: "text-muted small ps-4" }
const _hoisted_53 = { class: "d-flex flex-column gap-1" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  colspan: "2",
  class: "text-center ps-2"
}
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { class: "text-end text-nowrap pe-2 fw-bold" }
const _hoisted_58 = { class: "text-end text-nowrap pe-2 fw-bold" }
const _hoisted_59 = { class: "d-flex flex-wrap gap-2 justify-content-end align-items-center" }
const _hoisted_60 = ["onClick", "disabled"]
const _hoisted_61 = ["onClick", "disabled"]
const _hoisted_62 = ["onClick", "disabled"]
const _hoisted_63 = ["onClick", "disabled"]
const _hoisted_64 = {
  key: 4,
  class: "d-flex align-items-center gap-2 flex-wrap"
}
const _hoisted_65 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_66 = ["name", "id", "onUpdate:modelValue"]
const _hoisted_67 = ["for"]
const _hoisted_68 = ["name", "id", "onUpdate:modelValue"]
const _hoisted_69 = ["for"]
const _hoisted_70 = ["name", "id", "onUpdate:modelValue"]
const _hoisted_71 = ["for"]
const _hoisted_72 = ["onClick", "disabled"]
const _hoisted_73 = ["onClick", "disabled"]
const _hoisted_74 = ["onClick", "disabled"]
const _hoisted_75 = ["onClick", "disabled"]
const _hoisted_76 = ["onClick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WithdrawalForm = _resolveComponent("WithdrawalForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h5", null, "Retiros Pendientes de autorización", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.items.length), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _cache[26] || (_cache[26] = _createElementVNode("thead", { class: "table-light" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { style: {"width":"2.5rem"} }),
              _createElementVNode("th", null, "Creado"),
              _createElementVNode("th", null, "Por"),
              _createElementVNode("th", null, "Concepto"),
              _createElementVNode("th", {
                class: "text-center text-nowrap",
                style: {"min-width":"9rem"}
              }, " Total USD "),
              _createElementVNode("th", {
                class: "text-center text-nowrap",
                style: {"min-width":"9rem"}
              }, " Total BTC "),
              _createElementVNode("th", {
                class: "text-center",
                style: {"width":"8rem"}
              }, "Autorizaciones"),
              _createElementVNode("th", {
                class: "text-center",
                style: {"width":"9rem"}
              }, "Estado")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_ctx.items.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("td", {
                    colspan: "7",
                    class: "text-center text-muted py-4"
                  }, " No hay retiros pendientes ", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item._id
              }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("a", {
                      role: "button",
                      id: `dropdown-detail-${item._id}`,
                      class: _normalizeClass([
                      'fas',
                      _ctx.expanded[item._id]
                        ? 'fa-chevron-down'
                        : 'fa-chevron-right',
                      'fa-fw',
                      'm-1',
                      'text-decoration-none',
                      'link-secondary',
                      _ctx.expanded[item._id] ? '' : 'collapsed',
                    ]),
                      href: "#",
                      "aria-expanded": _ctx.expanded[item._id] || false,
                      "aria-controls": `detail-${item._id}`,
                      onClick: _withModifiers(($event: any) => (_ctx.toggleExpand(item._id)), ["prevent"])
                    }, null, 10, _hoisted_9)
                  ]),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.formatDate(item.dateCreated)), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.createdBy), 1),
                  _createElementVNode("td", _hoisted_12, [
                    (item.concept)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.concept), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_14, "Sin concepto"))
                  ]),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.totalUsdText(item)), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.totalBtcText(item)), 1),
                  _createElementVNode("td", _hoisted_17, [
                    (item.status === 'rejected')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("i", { class: "fas fa-thumbs-down" }, null, -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getApprovalStatus(item).total, (i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                              (i <= _ctx.getApprovalStatus(item).count)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                                : (_openBlock(), _createElementBlock("i", _hoisted_21))
                            ], 64))
                          }), 128))
                        ]))
                  ]),
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", _ctx.statusClass(item.status)])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass([_ctx.statusIcon(item.status), "me-1"])
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(_ctx.statusLabel(item.status)), 1)
                    ], 2)
                  ])
                ]),
                (_ctx.expanded[item._id])
                  ? (_openBlock(), _createElementBlock("tr", {
                      key: 0,
                      class: _normalizeClass([`detail-${item._id}`, "border-4 border-top-0 border-end-0 border-start-0 border-secondary"])
                    }, [
                      _cache[25] || (_cache[25] = _createElementVNode("td", {
                        class: "bg-secondary bg-gradient",
                        style: {"--bs-bg-opacity":"0.4"}
                      }, null, -1)),
                      _createElementVNode("td", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          (_ctx.isEditing(item._id))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createVNode(_component_WithdrawalForm, {
                                  mode: "edit",
                                  value: _ctx.editingValue,
                                  "btc-price": _ctx.btcPrice,
                                  "available-btc": _ctx.availableBtc,
                                  "submit-label": "Guardar cambios",
                                  loading: _ctx.isActionLoading(item._id, 'edit'),
                                  "validate-address-fn": _ctx.validateAddress,
                                  "auto-validate-on-load": true,
                                  "allow-add-remove": true,
                                  onSubmit: (payload) => _ctx.saveEdit(item._id, payload)
                                }, null, 8, ["value", "btc-price", "available-btc", "loading", "validate-address-fn", "onSubmit"]),
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("button", {
                                    class: "btn btn-outline-secondary btn-sm",
                                    type: "button",
                                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                                    disabled: _ctx.isActionLoading(item._id, 'edit')
                                  }, " Cancelar edición ", 8, _hoisted_27)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "small fw-bold mb-1" }, "Concepto:", -1)),
                                  _createElementVNode("div", _hoisted_30, [
                                    (item.concept && item.concept.trim())
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(item.concept), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_32, "Sin concepto"))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "small fw-bold mb-1" }, "Nota:", -1)),
                                  _createElementVNode("div", _hoisted_34, [
                                    (item.note && item.note.trim())
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(item.note), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_36, "Sin nota"))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("table", _hoisted_38, [
                                    _cache[15] || (_cache[15] = _createElementVNode("thead", { class: "table-secondary" }, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", {
                                          class: "text-center",
                                          style: {"width":"3rem"}
                                        }, "#"),
                                        _createElementVNode("th", {
                                          class: "text-nowrap",
                                          style: {"min-width":"16rem"}
                                        }, " Dirección "),
                                        _createElementVNode("th", {
                                          class: "text-center text-nowrap",
                                          style: {"min-width":"8rem"}
                                        }, " Moneda "),
                                        _createElementVNode("th", {
                                          class: "text-center text-nowrap",
                                          style: {"min-width":"10rem"}
                                        }, " Monto (USD) "),
                                        _createElementVNode("th", {
                                          class: "text-center text-nowrap",
                                          style: {"min-width":"10rem"}
                                        }, " Monto (BTC) "),
                                        _createElementVNode("th", {
                                          class: "text-nowrap",
                                          style: {"min-width":"12rem"}
                                        }, " Nota ")
                                      ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.destinations, (dest, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: dest.address + index
                                        }, [
                                          _createElementVNode("td", _hoisted_39, _toDisplayString(Number(index) + 1), 1),
                                          _createElementVNode("td", _hoisted_40, _toDisplayString(dest.address), 1),
                                          _createElementVNode("td", _hoisted_41, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["badge", _ctx.currencyBadgeClass(dest.currency)])
                                            }, _toDisplayString(dest.currency), 3)
                                          ]),
                                          _createElementVNode("td", _hoisted_42, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(_ctx.usdAmountClass(item, dest))
                                            }, _toDisplayString(_ctx.amountUsdText(item, dest)), 3)
                                          ]),
                                          _createElementVNode("td", _hoisted_43, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(_ctx.btcAmountClass(item, dest))
                                            }, _toDisplayString(_ctx.amountBtcText(item, dest)), 3)
                                          ]),
                                          _createElementVNode("td", _hoisted_44, [
                                            (dest.note)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(dest.note), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      }), 128))
                                    ]),
                                    _createElementVNode("tfoot", null, [
                                      (item.status === 'ready')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_46, [
                                            _cache[6] || (_cache[6] = _createElementVNode("td", null, null, -1)),
                                            _cache[7] || (_cache[7] = _createElementVNode("td", {
                                              colspan: "2",
                                              class: "text-end fw-bold pe-2"
                                            }, " Subtotal: ", -1)),
                                            _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.subtotalUsdText(item)), 1),
                                            _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.subtotalBtcText(item)), 1),
                                            _cache[8] || (_cache[8] = _createElementVNode("td", null, null, -1))
                                          ]))
                                        : _createCommentVNode("", true),
                                      (item.feeBtc)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_49, [
                                            _cache[10] || (_cache[10] = _createElementVNode("td", null, null, -1)),
                                            _cache[11] || (_cache[11] = _createElementVNode("td", {
                                              colspan: "2",
                                              class: "text-end fw-bold pe-2"
                                            }, " Comisión BC: ", -1)),
                                            _createElementVNode("td", _hoisted_50, " $ " + _toDisplayString(_ctx.formatUsd(item.feeUsd || 0)) + " USD ", 1),
                                            _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.formatBtc(item.feeBtc || 0)) + " BTC ", 1),
                                            _createElementVNode("td", _hoisted_52, [
                                              _createElementVNode("div", _hoisted_53, [
                                                (item.feeSpeed)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                                                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "fw-bold" }, "Velocidad:", -1)),
                                                      _createTextVNode(" " + _toDisplayString(_ctx.speedLabel(item.feeSpeed)), 1)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("td", _hoisted_55, [
                                          (item.feeBtcPrice)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                                                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "fw-bold" }, "Precio BTC:", -1)),
                                                _createTextVNode(" $ " + _toDisplayString(_ctx.formatUsd(item.feeBtcPrice)), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _cache[13] || (_cache[13] = _createElementVNode("td", { class: "fw-bold text-end pe-2" }, "Total:", -1)),
                                        _createElementVNode("td", _hoisted_57, [
                                          _createElementVNode("div", null, _toDisplayString(_ctx.totalUsdText(item)), 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_58, [
                                          _createElementVNode("div", null, _toDisplayString(_ctx.totalBtcText(item)), 1)
                                        ]),
                                        _cache[14] || (_cache[14] = _createElementVNode("td", null, null, -1))
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_59, [
                                  (
                            item.status === 'pending' ||
                            item.status === 'authorized' ||
                            item.status === 'rejected' ||
                            item.status === 'ready'
                          )
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-outline-secondary btn-sm",
                                        onClick: ($event: any) => (_ctx.cancel(item._id)),
                                        disabled: _ctx.isUpdating(item._id)
                                      }, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(
                              _ctx.isActionLoading(item._id, 'cancel')
                                ? 'fas fa-spinner fa-spin fa-fw me-1'
                                : 'far fa-trash-alt fa-fw me-1'
                            )
                                        }, null, 2),
                                        _cache[16] || (_cache[16] = _createTextVNode(" Cancelar ", -1))
                                      ], 8, _hoisted_60))
                                    : _createCommentVNode("", true),
                                  (_ctx.canEdit(item))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "btn btn-outline-warning btn-sm",
                                        onClick: ($event: any) => (_ctx.startEdit(item)),
                                        disabled: _ctx.isUpdating(item._id)
                                      }, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(
                              _ctx.isActionLoading(item._id, 'edit')
                                ? 'fas fa-spinner fa-spin fa-fw me-1'
                                : 'far fa-edit fa-fw me-1'
                            )
                                        }, null, 2),
                                        _cache[17] || (_cache[17] = _createTextVNode(" Editar ", -1))
                                      ], 8, _hoisted_61))
                                    : _createCommentVNode("", true),
                                  (_ctx.canAuthorize(item))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        class: "btn btn-outline-danger btn-sm",
                                        onClick: ($event: any) => (_ctx.reject(item._id)),
                                        disabled: _ctx.isUpdating(item._id)
                                      }, [
                                        _cache[18] || (_cache[18] = _createElementVNode("span", null, "Rechazar", -1)),
                                        _createElementVNode("i", {
                                          class: _normalizeClass(
                              _ctx.isActionLoading(item._id, 'reject')
                                ? 'fas fa-spinner fa-spin fa-fw ms-1'
                                : 'far fa-times-circle fa-fw ms-1'
                            )
                                        }, null, 2)
                                      ], 8, _hoisted_62))
                                    : _createCommentVNode("", true),
                                  (item.status === 'pending' && _ctx.canAuthorize(item))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 3,
                                        class: "btn btn-success btn-sm text-light",
                                        onClick: ($event: any) => (_ctx.authorize(item._id)),
                                        disabled: _ctx.isUpdating(item._id)
                                      }, [
                                        _cache[19] || (_cache[19] = _createElementVNode("span", null, "Aprobar", -1)),
                                        _createElementVNode("i", {
                                          class: _normalizeClass(
                              _ctx.isActionLoading(item._id, 'authorize')
                                ? 'fas fa-spinner fa-spin fa-fw ms-1'
                                : 'far fa-check-circle fa-fw ms-1'
                            )
                                        }, null, 2)
                                      ], 8, _hoisted_63))
                                    : _createCommentVNode("", true),
                                  (
                            item.status === 'authorized' ||
                            item.status === 'ready'
                          )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                        _createElementVNode("div", _hoisted_65, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "btn-check",
                                            type: "radio",
                                            name: `speed-${item._id}`,
                                            id: `speed-${item._id}-slow`,
                                            value: "slow",
                                            autocomplete: "off",
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.selectedSpeed[item._id]) = $event)
                                          }, null, 8, _hoisted_66), [
                                            [_vModelRadio, _ctx.selectedSpeed[item._id]]
                                          ]),
                                          _createElementVNode("label", {
                                            class: "btn btn-outline-info",
                                            for: `speed-${item._id}-slow`
                                          }, " Lenta ", 8, _hoisted_67),
                                          _withDirectives(_createElementVNode("input", {
                                            class: "btn-check",
                                            type: "radio",
                                            name: `speed-${item._id}`,
                                            id: `speed-${item._id}-standard`,
                                            value: "standard",
                                            autocomplete: "off",
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.selectedSpeed[item._id]) = $event)
                                          }, null, 8, _hoisted_68), [
                                            [_vModelRadio, _ctx.selectedSpeed[item._id]]
                                          ]),
                                          _createElementVNode("label", {
                                            class: "btn btn-outline-info",
                                            for: `speed-${item._id}-standard`
                                          }, " Estándar ", 8, _hoisted_69),
                                          _withDirectives(_createElementVNode("input", {
                                            class: "btn-check",
                                            type: "radio",
                                            name: `speed-${item._id}`,
                                            id: `speed-${item._id}-fast`,
                                            value: "fast",
                                            autocomplete: "off",
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.selectedSpeed[item._id]) = $event)
                                          }, null, 8, _hoisted_70), [
                                            [_vModelRadio, _ctx.selectedSpeed[item._id]]
                                          ]),
                                          _createElementVNode("label", {
                                            class: "btn btn-outline-info",
                                            for: `speed-${item._id}-fast`
                                          }, " Rápida ", 8, _hoisted_71)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (
                            item.status === 'authorized' ||
                            item.status === 'ready'
                          )
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 5,
                                        class: _normalizeClass(["btn btn-sm", {
                            'btn-secondary': item.status === 'authorized',
                            'btn-outline-secondary': item.status === 'ready',
                          }]),
                                        onClick: ($event: any) => (_ctx.calculateFee(item._id)),
                                        disabled: _ctx.isUpdating(item._id)
                                      }, [
                                        _cache[20] || (_cache[20] = _createElementVNode("span", null, "Calcular", -1)),
                                        _createElementVNode("i", {
                                          class: _normalizeClass(
                              _ctx.isActionLoading(item._id, 'calculate')
                                ? 'fas fa-spinner fa-spin fa-fw ms-1'
                                : 'fas fa-calculator fa-fw ms-1'
                            )
                                        }, null, 2)
                                      ], 10, _hoisted_72))
                                    : _createCommentVNode("", true),
                                  (item.status === 'ready')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 6,
                                        class: "btn btn-success text-light btn-sm",
                                        onClick: ($event: any) => (_ctx.sendTransaction(item._id)),
                                        disabled: _ctx.isUpdating(item._id)
                                      }, [
                                        _cache[21] || (_cache[21] = _createElementVNode("span", null, "Enviar", -1)),
                                        _createElementVNode("i", {
                                          class: _normalizeClass(
                              _ctx.isActionLoading(item._id, 'send')
                                ? 'fas fa-spinner fa-spin fa-fw ms-1'
                                : 'fas fa-sign-out-alt fa-fw ms-1'
                            )
                                        }, null, 2)
                                      ], 8, _hoisted_73))
                                    : _createCommentVNode("", true),
                                  (item.status === 'failed')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 7,
                                        class: "btn btn-outline-danger btn-sm",
                                        onClick: ($event: any) => (_ctx.retry(item._id)),
                                        disabled: _ctx.isUpdating(item._id)
                                      }, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(
                              _ctx.isActionLoading(item._id, 'retry')
                                ? 'fas fa-spinner fa-spin fa-fw me-1'
                                : 'fas fa-undo fa-fw me-1'
                            )
                                        }, null, 2),
                                        _cache[22] || (_cache[22] = _createTextVNode(" Recuperar ", -1))
                                      ], 8, _hoisted_74))
                                    : _createCommentVNode("", true),
                                  (
                            item.status === 'rejected' ||
                            item.status === 'canceled'
                          )
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 8,
                                        class: "btn btn-outline-secondary btn-sm",
                                        onClick: ($event: any) => (_ctx.reopen(item._id)),
                                        disabled: _ctx.isUpdating(item._id)
                                      }, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(
                              _ctx.isActionLoading(item._id, 'reopen')
                                ? 'fas fa-spinner fa-spin fa-fw me-1'
                                : 'fas fa-trash-restore fa-fw me-1'
                            )
                                        }, null, 2),
                                        _cache[23] || (_cache[23] = _createTextVNode(" Restaurar ", -1))
                                      ], 8, _hoisted_75))
                                    : _createCommentVNode("", true),
                                  (item.status === 'canceled')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 9,
                                        class: "btn btn-outline-danger btn-sm",
                                        onClick: ($event: any) => (_ctx.deleteReq(item._id)),
                                        disabled: _ctx.isUpdating(item._id)
                                      }, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(
                              _ctx.isActionLoading(item._id, 'delete')
                                ? 'fas fa-spinner fa-spin fa-fw me-1'
                                : 'fas fa-trash fa-fw me-1'
                            )
                                        }, null, 2),
                                        _cache[24] || (_cache[24] = _createTextVNode(" Eliminar ", -1))
                                      ], 8, _hoisted_76))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                        ])
                      ])
                    ], 2))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}